import styled from "styled-components";
import React, { PropsWithChildren, useCallback } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

const StyledLink = styled.a`
  text-decoration: none;
  cursor: pointer;
`;

interface LinkContainerProps {
  to: string;
}

export const LinkContainer = ({
  to,
  children,
}: PropsWithChildren<LinkContainerProps>) => {
  const dispatch = useDispatch();

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      dispatch(push(to));
    },
    [dispatch, to]
  );

  return React.createElement(StyledLink, { onClick: handleClick }, children);
};
